export default __webpack_public_path__ + "static/media/yellow_v2.9c9040e0.png";